import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import delivaApiService from '../common/services/apiService';
import { showErrorToast } from '../common/helpers/Utils';

const AgentReferral = () => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState('');

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get('referralCode');
  const reqId = queryParams.get('reqId');
  const source = queryParams.get('source');

  const handleEmailSubmit = async () => {
    if (!email) {
      setEmailError('Email is required');
      return;
    }

    // Updated regex to prevent multiple '@' and repeated domain parts
    const emailRegex = /^(?!.*(\.[a-zA-Z]{2,})(?:\1)+)[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      const requestBody = {
        referralCode: referralCode,
        source: source,
        reqId: reqId,
        email: email,
        roleId: 3,
      };

      const response = await delivaApiService('referralLink', requestBody);
      console.log('API Response:', response);

      if (response && response.data.status === 409) {
        setEmailError(response.data.responseMessage || "Email already exists");
        return;
      } else if (!response || response.status !== 200) {
        const errorMessage =
          (response && response.data && response.data.responseMessage) ||
          'Failed to submit. Please try again.';
        showErrorToast(errorMessage);
        return; // keep modal open
      }

      setShowModal(false);

      const androidStoreUrl = `https://play.google.com/store/apps/details?id=com.deliva.da`;
      const iosStoreUrl = `https://apps.apple.com/in/app/delivahere-agent/id6502445529`;
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      window.location.href = isIOS ? iosStoreUrl : androidStoreUrl;
    } catch (error) {
      console.error('API Error:', error);
      showErrorToast('Failed to submit. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const deepLink = `myapp://com.deliva.da?referralCode=${referralCode}`;
    const androidStoreUrl = `https://play.google.com/store/apps/details?id=com.deliva.da`;
    const iosStoreUrl = `https://apps.apple.com/in/app/delivahere-agent/id6502445529`;
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const hasParams = Boolean(referralCode || reqId || source);

    if (hasParams) {
      setShowModal(true);
    }

    // Always attempt deep link so permission prompt can appear even with the modal open
    try {
      window.location.href = deepLink;
    } catch (e) {
      // no-op
    }

    // Only schedule store fallback if there is no modal (no params)
    let timer;
    if (!hasParams) {
      timer = setTimeout(() => {
        window.location.href = isIOS ? iosStoreUrl : androidStoreUrl;
      }, 5000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [referralCode, reqId, source]);

  return (
    <>
      <Modal show={showModal} className="reffealLinkModelPopup">
        <Modal.Header closeButton={false}>
          <Modal.Title>Enter Your Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <Col lg={12}>
                <Form>
                  <Form.Group controlId="email" className="custom-form">
                    <Form.Label className="color-head">
                      Email Address <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      className="py-0"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (emailError) setEmailError('');
                      }}
                      isInvalid={!!emailError}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className="text-danger"
                    >
                      {emailError}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="b1-btn"
            onClick={handleEmailSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : 'Submit'}
          </button>
        </Modal.Footer>
      </Modal>

      {!showModal && (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <h1 className="text-center">Please wait...</h1>
        </div>
      )}
    </>
  );
};

export default AgentReferral;
